// src/icons.js
  export {
    default as CaretDownFill
  } from '@ant-design/icons/lib/fill/CaretDownFill';

  export {
    default as FolderOpenOutline
  } from '@ant-design/icons/lib/outline/FolderOpenOutline.js';

  export {
    default as FolderOutline
  } from '@ant-design/icons/lib/outline/FolderOutline.js';

  export {
    default as FileOutline
  } from '@ant-design/icons/lib/outline/FileOutline.js';

  export {
    default as CalendarOutline  
  } from '@ant-design/icons/lib/outline/CalendarOutline';